
import apiCalls from "src/api/apiCalls";
const SET_ADMIN_TYPE = 'setadmintype';
const SET_CARDSPERMISSIONS_CONFIG = "setcardspermissionsconfig"
const SET_HIGHLIGHTEDMENUITEM = "highlightMenuitem"
const SET_MODULES = "setModules";

const setadmintype = (payload) => {
    return {
        type: SET_ADMIN_TYPE,
        payload,
    };
};
const setcardspermissionsconfig = (payload) => {
    return {
        type: SET_CARDSPERMISSIONS_CONFIG,
        payload,
    };
}
const highlightMenuitem = (payload) => {
    return {
        type: SET_HIGHLIGHTEDMENUITEM,
        payload,
    };
}
const setModules = (payload) => {
    return {
        type: SET_MODULES,
        payload,
    };
}

const getModules = () => {
    return async (dispatch) => {
        const response = await apiCalls.fetchModules();
        if (response.ok) {
            dispatch(setModules(response.data))
        }
    }
}

let initialState = {
    AdminType: '', cardspermissionsconfig: {}, highlightedmenuItem: '', modules: []
};
const commonReducer = (state, action) => {
    if (!state) {
        state = {
            ...initialState,
            ...state
        }
    }
    switch (action.type) {
        case SET_ADMIN_TYPE:
            state = { ...state, AdminType: action.payload };
            return state;
        case SET_CARDSPERMISSIONS_CONFIG:
            state = { ...state, cardspermissionsconfig: action.payload };
            return state;
        case SET_HIGHLIGHTEDMENUITEM:
            state = { ...state, highlightedmenuItem: action.payload };
            return state;
        case SET_MODULES:
            state = { ...state, modules: action.payload };
            return state;
        default:
            return state;
    }
}

export default commonReducer;
export { setadmintype, setcardspermissionsconfig, highlightMenuitem, getModules };

